import t from '../render/utils/i18n';

/** 错误码 → state 转移 / toast 的分流路由。
 *  RH-B5 硬约束:仅按 businessCode + 独立 reason 参数分流,
 *  禁止读取业务文案字符串做机器判断(人类可读文案仅作兜底,不进入分流逻辑) */
export type AmoeErrorRouting =
  | { kind: 'toast'; message: string }
  | { kind: 'alreadyMoomoo' }
  | { kind: 'duplicate' }
  | { kind: 'ipRejected' }
  | { kind: 'noEntries' }
  | { kind: 'noRound'; reason: 'not_started' | 'ended' | 'no_round' };

type AvailabilityReason = 'not_started' | 'ended' | 'no_round';

type AmoeBusinessErrorLike = {
  businessCode?: unknown;
  rawResponse?: { code?: unknown };
};

/**
 * 提取 AMOE 前端链路中的业务错误码。
 *
 * 标准链路读 ApiError.businessCode；Fego request 对业务失败会把原始响应保留在
 * rawResponse.code，这里复制 prize list 兑换链路已验证口径，避免前端承担过宽协议适配。
 */
export function getAmoeBusinessCode(err: unknown): number | undefined {
  const source = err as AmoeBusinessErrorLike;
  const bc = source.businessCode;
  if (typeof bc === 'number' && bc >= 30000) return bc;
  const rc = source.rawResponse?.code;
  if (typeof rc === 'number' && rc >= 30000) return rc;
  return undefined;
}

function normalizeReason(
  reason: AvailabilityReason | undefined,
): AvailabilityReason {
  if (reason === 'not_started' || reason === 'ended' || reason === 'no_round')
    return reason;
  return 'no_round';
}

/** D-31 + RH-B5: 仅按 businessCode + availabilityReason 分流。
 *  调用方:
 *  - submit 业务错 → 传 rsp.reason(来自 AmoeSubmitRsp success=false 分支的独立 reason 字段)
 *  - availability 业务错 → 传 rsp.reason(来自 AmoeAvailabilityRsp.reason)
 *  - submit 非业务错/SMS 错 → 仅传 businessCode,reason 省略 */
export function getAmoeErrorRouting(
  businessCode: number,
  availabilityReason?: AvailabilityReason,
): AmoeErrorRouting {
  switch (businessCode) {
    case 31031:
      return { kind: 'alreadyMoomoo' };
    case 31020:
    case 31032:
      return { kind: 'duplicate' };
    case 31033:
      return { kind: 'ipRejected' };
    case 31012:
      return { kind: 'noEntries' };
    case 31011:
    case 31041:
      return { kind: 'noRound', reason: normalizeReason(availabilityReason) };
    case 31021:
      return { kind: 'toast', message: t('amoe.errors.31021') };
    case 31022:
      return { kind: 'toast', message: t('amoe.errors.31022') };
    case 31023:
      return { kind: 'toast', message: t('amoe.errors.31023') };
    case 31024:
      return { kind: 'toast', message: t('amoe.errors.31024') };
    case 31025:
      return { kind: 'toast', message: t('amoe.errors.31025') };
    default:
      return { kind: 'toast', message: t('amoe.errors.network') };
  }
}
